import { useHistory } from 'react-router-dom';

import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { toast } from '@dashboard/context/ToastContext';
import { useAdminGhosting } from '@dashboard/context/AdminGhostingContext/AdminGhostingContext';

export default function useViewAsMerchant() {
  const history = useHistory();
  const { logAdminInAsSeller } = useAuth();
  const { setAdminGhostingSellerId } = useAdminGhosting();

  return async (sellerId, path = '/') => {
    await logAdminInAsSeller(sellerId);
    setAdminGhostingSellerId(sellerId);

    toast({ title: 'Logged in as merchant' });

    history.push(path);
  };
}
